module.exports = "\n<div class=\"form-group m-form__group row\"  style=\"margin:10px\" >\n    <label class=\"col-xl-3 col-lg-3 col-form-label\">{{label}}</label>\n    <div class=\"col-xl-9 col-lg-9\">\n        <ng-content></ng-content>\n        <div  class=\"form-control-feedback\">\n            <div style=\"color:red\">\n        <ng-content select=[error]></ng-content>\n        </div>\n    </div>\n    </div>\n</div> \n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/custom-component/formGroup.component.1.html
// module id = ./src/app/theme/layouts/custom-component/formGroup.component.1.html
// module chunks = main